module.exports = __webpack_public_path__ + "static/media/mdwa.34af6454.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/mdwa.eot?62057485
// module id = 14
// module chunks = 0